import { CLEAR, UPSERT, UserDetailsActions } from './user-details.actions';

import { UserDetails } from '../../shared/model';
import { LabsysContactActions } from '../../../store/labsys-contact/labsys-contact.actions';

export interface State {
    userDetails: UserDetails;
}

const initialState = {
    userDetails: null
};

export function reducer(state = initialState, action: UserDetailsActions | LabsysContactActions) {
    switch (action.type) {
    case UPSERT:
        return {
            ...state,
            userDetails: { ...state.userDetails, ...action.payload },
        };
    case CLEAR:
        return {
            ...state,
            userDetails: null,
        };
    default:
        return state;
    }
}

export const getUserDetails = (state: State) => state.userDetails;


